<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.wechatV3Pay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- 应用场景 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.wechatV3Pay.application") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ $t("Payment.wechatV3Pay.application_title") }}
                </v-col>
              </v-row>
              <!-- wechat_v3_url -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatV3Pay.wechat_v3_url") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatV3Pay.wechat_v3_url')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_v3_url"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_v3_url')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- wechat_v3_appid -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatV3Pay.wechat_v3_appid") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatV3Pay.wechat_v3_appid')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_v3_appid"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_v3_appid')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- wechat_v3_mchid -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatV3Pay.wechat_v3_mchid") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatV3Pay.wechat_v3_mchid')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_v3_mchid"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_v3_mchid')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- wechat_v3_serial_number -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatV3Pay.wechat_v3_serial_number") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatV3Pay.wechat_v3_serial_number')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_v3_serial_number"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_v3_serial_number')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- wechat_v3_private_secrect -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatV3Pay.wechat_v3_private_secrect") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatV3Pay.wechat_v3_private_secrect')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_v3_private_secrect"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_v3_private_secrect')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- wechat_v3_private_key -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.wechatV3Pay.wechat_v3_private_key") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatV3Pay.wechat_v3_private_key')"
                    :rules="!settings.wechat_v3_private_key ? 'required' : null"
                  >
                    <v-file-input
                      v-model="wechat_v3_private_key"
                      show-size
                      :label="$t('Payment.wechatV3Pay.wechat_v3_private_key_import')"
                      accept=".pem"
                      persistent-hint
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_v3_private_key')
                          .concat(errors)
                      "
                    ></v-file-input>
                  </ValidationProvider>
                  <span v-if="settings.wechat_v3_private_key">
                    {{ $t("Payment.wechatV3Pay.upload_file", [settings.wechat_v3_private_key.split('/')[settings.wechat_v3_private_key.split('/').length - 1]]) }}
                  </span>
                </v-col>
              </v-row>

              <!-- wechat_v3_certificate -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.wechatV3Pay.wechat_v3_certificate") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatV3Pay.wechat_v3_certificate')"
                    :rules="!settings.wechat_v3_certificate ? 'required' : null"
                  >
                    <v-file-input
                      v-model="wechat_v3_certificate"
                      show-size
                      :label="$t('Payment.wechatV3Pay.wechat_v3_certificate_import')"
                      accept=".pem"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_v3_certificate')
                          .concat(errors)
                      "
                    ></v-file-input>
                  </ValidationProvider>
                  <span v-if="settings.wechat_v3_certificate">
                    {{ $t("Payment.wechatV3Pay.upload_file", [settings.wechat_v3_certificate.split('/')[settings.wechat_v3_certificate.split('/').length - 1]]) }}
                  </span>
                </v-col>
              </v-row>

              <!-- wechat_v3_certificate_serial_number -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatV3Pay.wechat_v3_certificate_serial_number") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatV3Pay.wechat_v3_certificate_serial_number')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_v3_certificate_serial_number"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_v3_certificate_serial_number')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- 启用 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatV3Pay.wechat_v3_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.wechat_v3_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                @click="
                  settings.wechat_mini_enable ? (alertDialog = true) : save()
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <DialogAlert
      v-model="alertDialog"
      :message="$t('Payment.change_wechat_pay', [$t('Payment.wechat')])"
      useConfirm
      @confirm="save()"
    />
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogAlert from "@/components/plugins/DialogAlert";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import Required from "@/components/plugins/Required";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
    alertDialog: false,
    wechat_v3_private_key: null,
    wechat_v3_certificate: null
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    DialogAlert,
    // Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },
  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: [
          "wechat_v3_url",
          "wechat_v3_appid",
          "wechat_v3_mchid",
          "wechat_v3_serial_number",
          "wechat_v3_private_secrect",
          "wechat_v3_private_key",
          "wechat_v3_certificate",
          "wechat_v3_certificate_serial_number",
          "wechat_v3_enable"
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (
              this.settings.wechat_mini_enable == null ||
              typeof this.settings.wechat_mini_enable == "undefined" ||
              this.settings.wechat_mini_enable == undefined
            ) {
              this.settings.wechat_mini_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    async save() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            let submitItems = {
              wechat_v3_url : this.settings.wechat_v3_url,
              wechat_v3_appid : this.settings.wechat_v3_appid,
              wechat_v3_mchid : this.settings.wechat_v3_mchid,
              wechat_v3_serial_number : this.settings.wechat_v3_serial_number,
              wechat_v3_private_secrect : this.settings.wechat_v3_private_secrect,
              wechat_v3_private_key : this.settings.wechat_v3_private_key,
              wechat_v3_certificate : this.settings.wechat_v3_certificate,
              wechat_v3_certificate_serial_number : this.settings.wechat_v3_certificate_serial_number,
              wechat_v3_enable : this.settings.wechat_v3_enable,
            }
            if (this.wechat_v3_private_key) {
              let response = await Payment.wechatV3FileUpload(1, this.wechat_v3_private_key);
              if (response.data.status.isOK()) {
                submitItems.wechat_v3_private_key = response.data.wechat_v3_private_key
              }
            }
            if (this.wechat_v3_certificate) {
              let response = await Payment.wechatV3FileUpload(2, this.wechat_v3_certificate);
              if (response.data.status.isOK()) {
                submitItems.wechat_v3_certificate = response.data.wechat_v3_certificate
              }
            }
            Payment.wechatV3PaySave(submitItems).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$store.dispatch("fullscreenLoadingStop");
                  this.$router.push("/payment");
                } else {
                  this.$store.dispatch("fullscreenLoadingStop");
                }
              }.bind(this)
            ).catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
      // if (this.wechat_v3_private_key) {
      //   Payment.wechatV3FileUpload(1, this.wechat_v3_private_key);
      // }
      // if (this.wechat_v3_certificate) {
      //   Payment.wechatV3FileUpload(2, this.wechat_v3_certificate);
      // }

    },
  },
};
</script>

<style>
</style>